import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    SEND_OTP_FOR_FORGOT_PASSWORD,
    sendOtpForForgotPasswordFail,
    sendOtpForForgotPasswordSuccess
} from '../action/sendOtpForForgotPasswordAction'

// api 
import sendOtpForForgotPasswordApi from '../api/sendOtpForForgotPasswordApi'

export function* sendOtpForForgotPasswordSaga(action) {
    try {
        const response = yield call(() => sendOtpForForgotPasswordApi(action.params))
        if (response.data.statusCode === 200) {
            yield put(sendOtpForForgotPasswordSuccess(response, action))
        } else {
            yield put(sendOtpForForgotPasswordFail(response, action))
        }
    }
    catch (e) {
        yield put(sendOtpForForgotPasswordFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(SEND_OTP_FOR_FORGOT_PASSWORD, sendOtpForForgotPasswordSaga)
}
